<template>
  <div>
    <div class="filter-label">
      Thermostat Zone
    </div>
    <div class="filter-options">
      <div
        v-for="(z, index) in systemFilterOptions"
        :key="index"
      >
        <div>
          <div
            :class="[ isUidFilterActive(uIds, z.uId) ? 'active' : '', 'option' ]"
            @click="handleSystemFilters('uId', z.uId, !!isUidFilterActive(uIds, z.uId))"
          >
            {{ z.manufacturer }} - {{ z.systemName }}
          </div>
          <div
            v-for="(tz, index) in z.thermostatZones"
            :key="index"
            class="p-5"
          >
            <SACCheckbox
              :label="`${tz.zone} (${tz.serialNumber.slice(tz.serialNumber.length - 5)})`"
              field="thermostatZone"
              :checked="isTZoneActive(uIds, z.uId, tz.serialNumber)"
              :change="() => handleSystemFilters(
                'tZoneSN',
                tz.serialNumber,
                !!isTZoneActive(uIds, z.uId, tz.serialNumber)
              )"
            />
          </div>
        </div>
      </div>
      <div
        v-if="systemFilterOptions.length > 1 && activeTab !== 'runtime'"
        :class="['all-zone', all ? 'active' : '']"
        @click="handleSystemFilters(
          'allTZoneSelected',
          true,
        )"
      >
        All
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SACCheckbox from '../../sac/SACCheckbox.vue';

export default {
  name: 'ThermostatZoneFilter',
  components: {
    SACCheckbox,
  },
  computed: {
    ...mapState({
      systemFilterOptions: state => state.customerDetail.systemFilterOptions,
      uIds: state => state.customerDetail.systemFilter.thermostatZone,
      all: state => state.customerDetail.systemFilter.allTZoneSelected,
      activeTab: state => state.customerDetail.activeTab,
    }),
  },
  methods: {
    isUidFilterActive(uIds, value) {
      const uId = uIds.find(f => f.uId === value);
      return !!uId;
    },
    isTZoneActive(uIds, cUid, cSN) {
      const uId = uIds.find(f => f.uId === cUid);
      if (uId) {
        const tZones = uId.tZoneSN;
        return tZones.includes(cSN);
      }
      return false;
    },
    handleSystemFilters(field, value, checked) {
      this.$store.dispatch(
        'setDetailSystemFilter',
        {
          field,
          value,
          checked,
        },
      );
      this.show = false;
    },
  },
};
</script>

<style scoped>

</style>
